export default __webpack_public_path__ + "static/media/A_human_abdomen.b2e3abf7.png";